/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractSortBy } from '../models/ContractSortBy';
import type { CreateContractRequest } from '../models/CreateContractRequest';
import type { CreateContractResponse } from '../models/CreateContractResponse';
import type { CreateCounterpartRequest } from '../models/CreateCounterpartRequest';
import type { CreateCounterpartResponse } from '../models/CreateCounterpartResponse';
import type { CreateOtherInstitutionRequest } from '../models/CreateOtherInstitutionRequest';
import type { CreateOtherInstitutionResponse } from '../models/CreateOtherInstitutionResponse';
import type { GetActiveContractListResponse } from '../models/GetActiveContractListResponse';
import type { GetContractedInternalInstitutionListResponse } from '../models/GetContractedInternalInstitutionListResponse';
import type { GetContractListResponse } from '../models/GetContractListResponse';
import type { GetContractResponse } from '../models/GetContractResponse';
import type { GetCounterpartListResponse } from '../models/GetCounterpartListResponse';
import type { GetCounterpartResponse } from '../models/GetCounterpartResponse';
import type { GetInternalInstitutionListResponse } from '../models/GetInternalInstitutionListResponse';
import type { GetInternalInstitutionResponse } from '../models/GetInternalInstitutionResponse';
import type { GetOtherInstitutionListResponse } from '../models/GetOtherInstitutionListResponse';
import type { GetOtherInstitutionResponse } from '../models/GetOtherInstitutionResponse';
import type { InternalInstitutionSortBy } from '../models/InternalInstitutionSortBy';
import type { LegalEntityStatus } from '../models/LegalEntityStatus';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { OrganizationationalPosition } from '../models/OrganizationationalPosition';
import type { OtherInstitutionSortBy } from '../models/OtherInstitutionSortBy';
import type { UpdateContractRequest } from '../models/UpdateContractRequest';
import type { UpdateContractResponse } from '../models/UpdateContractResponse';
import type { UpdateCounterpartRequest } from '../models/UpdateCounterpartRequest';
import type { UpdateCounterpartResponse } from '../models/UpdateCounterpartResponse';
import type { UpdateOtherInstitutionRequest } from '../models/UpdateOtherInstitutionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CounterpartService {
    /**
     * Updates other institution (specific type of counterpart).
     * Updates other institution (specific type of counterpart) with provided details.
     * @param id Other institution identifier.
     * @param requestBody
     * @returns UpdateCounterpartResponse The other institution has been updated successfully.
     * @throws ApiError
     */
    public static updateOtherInstitutionEndpoint(
        id: string,
        requestBody: UpdateOtherInstitutionRequest,
    ): CancelablePromise<UpdateCounterpartResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/other-institutions/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The other institution has not been found.`,
            },
        });
    }
    /**
     * Gets other institution (specific type of counterpart).
     * Gets other institution (specific type of counterpart) with details.
     * @param id Other institution identifier.
     * @returns GetOtherInstitutionResponse The other institution has been found.
     * @throws ApiError
     */
    public static getOtherInstitutionEndpoint(
        id: string,
    ): CancelablePromise<GetOtherInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/other-institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The other institution has not been found.`,
            },
        });
    }
    /**
     * Deletes other institution (specific type of counterpart).
     * Deletes other institution (specific type of counterpart) by its id.
     * @param id Other institution identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteOtherInstitutionEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/other-institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The othe institution has not been found.`,
            },
        });
    }
    /**
     * Gets a list of other institutions.
     * Gets a list of other institutions.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by IDNO, fiscal code or other institution name.
     * @param subtype Search by other institution subtype.
     * @param status
     * @param sortBy Sort by IDNO, fiscal code or other institution name.
     * @param sortDirection Sort direction for other institution name.
     * @returns GetOtherInstitutionListResponse The other institution list has been found.
     * @throws ApiError
     */
    public static getOtherInstitutionListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        subtype?: string | null,
        status?: LegalEntityStatus | null,
        sortBy?: OtherInstitutionSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetOtherInstitutionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/other-institutions',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'subtype': subtype,
                'status': status,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates other institution (specific type of counterpart).
     * Creates other institution (specific type of counterpart) without details.
     * @param requestBody
     * @returns CreateOtherInstitutionResponse The other institution has been created successfully.
     * @throws ApiError
     */
    public static createOtherInstitutionEndpoint(
        requestBody: CreateOtherInstitutionRequest,
    ): CancelablePromise<CreateOtherInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/other-institutions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of internal institutions.
     * Gets a list of internal institutions.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param ids
     * @param searchTerm Search by IDNO, fiscal code or internal institution name.
     * @param subtype Search by internal institution subtype.
     * @param status
     * @param position
     * @param sortBy Sort by IDNO, fiscal code or internal institution name.
     * @param sortDirection Sort direction for internal institution name.
     * @returns GetInternalInstitutionListResponse The internal institution list has been found.
     * @throws ApiError
     */
    public static getInternalInstitutionListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        ids?: Array<string> | null,
        searchTerm?: string | null,
        subtype?: string | null,
        status?: LegalEntityStatus | null,
        position?: OrganizationationalPosition | null,
        sortBy?: InternalInstitutionSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetInternalInstitutionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/internal-institutions',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'ids': ids,
                'searchTerm': searchTerm,
                'subtype': subtype,
                'status': status,
                'position': position,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets internal institution (specific type of counterpart).
     * Gets internal institution (specific type of counterpart) with details.
     * @param id Internal institution identifier.
     * @returns GetInternalInstitutionResponse The internal institution has been found.
     * @throws ApiError
     */
    public static getInternalInstitutionEndpoint(
        id: string,
    ): CancelablePromise<GetInternalInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/internal-institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The internal institution has not been found.`,
            },
        });
    }
    /**
     * Updates a counterpart.
     * Updates a counterpart with provided details.
     * @param id Counterpart identifier.
     * @param requestBody
     * @returns UpdateCounterpartResponse The counterpart has been updated successfully.
     * @throws ApiError
     */
    public static updateCounterpartEndpoint(
        id: string,
        requestBody: UpdateCounterpartRequest,
    ): CancelablePromise<UpdateCounterpartResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/counterparts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The counterpart has not been found.`,
            },
        });
    }
    /**
     * Gets a counterpart.
     * Gets a counterpart with details.
     * @param id Counterpart identifier.
     * @returns GetCounterpartResponse The counterpart has been found.
     * @throws ApiError
     */
    public static getCounterpartEndpoint(
        id: string,
    ): CancelablePromise<GetCounterpartResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/counterparts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The counterpart has not been found.`,
            },
        });
    }
    /**
     * Deletes a counterpart.
     * Deletes a counterpart by its id.
     * @param id Counterpart identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteCounterpartEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/counterparts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The counterpart has not been found.`,
            },
        });
    }
    /**
     * Gets a list of counterparts.
     * Gets a list of counterparts.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param counterpartName Search by counterpart name. Partial search supported.
     * @param contractNumber Search by contract number, if IncludeTheLastSignedContract is enabled. Partial search supported.
     * @param contractStartDate Search by contract start date, if IncludeTheLastSignedContract is enabled.
     * @param contractEndDate Search by contract end date, if IncludeTheLastSignedContract is enabled.
     * @param status
     * @param sortDirection Sort direction for counterpart name.
     * @param includeTheLastSignedContract Includes the last signed contract, no contracts by default.
     * @returns GetCounterpartListResponse The counterpart list has been found.
     * @throws ApiError
     */
    public static getCounterpartListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        counterpartName?: string | null,
        contractNumber?: string | null,
        contractStartDate?: string | null,
        contractEndDate?: string | null,
        status?: LegalEntityStatus | null,
        sortDirection?: ListSortDirection | null,
        includeTheLastSignedContract: boolean = false,
    ): CancelablePromise<GetCounterpartListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/counterparts',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'counterpartName': counterpartName,
                'contractNumber': contractNumber,
                'contractStartDate': contractStartDate,
                'contractEndDate': contractEndDate,
                'status': status,
                'sortDirection': sortDirection,
                'includeTheLastSignedContract': includeTheLastSignedContract,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a counterpart.
     * Creates a counterpart.
     * @param requestBody
     * @returns CreateCounterpartResponse The counterpart has been created successfully.
     * @throws ApiError
     */
    public static createCounterpartEndpoint(
        requestBody: CreateCounterpartRequest,
    ): CancelablePromise<CreateCounterpartResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/counterparts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Updates a contract.
     * Updates a contract with provided details.
     * @param id Contract identifier.
     * @param requestBody
     * @returns UpdateContractResponse The contract has been updated successfully.
     * @throws ApiError
     */
    public static updateContractEndpoint(
        id: string,
        requestBody: UpdateContractRequest,
    ): CancelablePromise<UpdateContractResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/contracts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The contract has not been found.`,
            },
        });
    }
    /**
     * Gets a contract.
     * Gets a contract with details.
     * @param id Contract identifier.
     * @returns GetContractResponse The contract has been found.
     * @throws ApiError
     */
    public static getContractEndpoint(
        id: string,
    ): CancelablePromise<GetContractResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The contract has not been found.`,
            },
        });
    }
    /**
     * Deletes a contract.
     * Deletes a contract by its id.
     * @param id Contract identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteContractEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The contract has not been found.`,
            },
        });
    }
    /**
     * Gets a list of contracts.
     * Gets a list of contracts.
     * @param counterpartId Counterpart to which contracts are linked.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by contract number or description.
     * @param sortBy Sort by contract number, contract start date and contract end date.
     * @param sortDirection Sort direction for contract number, contract start date and contract end date.
     * @returns GetContractListResponse The contract list has been found.
     * @throws ApiError
     */
    public static getContractListEndpoint(
        counterpartId: string,
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        sortBy?: ContractSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetContractListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/contracts',
            query: {
                'counterpartId': counterpartId,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a contract.
     * Creates a contract without details.
     * @param requestBody
     * @returns CreateContractResponse The contract has been created successfully.
     * @throws ApiError
     */
    public static createContractEndpoint(
        requestBody: CreateContractRequest,
    ): CancelablePromise<CreateContractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/contracts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of active contracts per institution.
     * Gets a list of active contracts per institution.
     * @param legalEntityId Legal entity identifier filter.
     * @returns GetContractedInternalInstitutionListResponse The list of active contracts has been found.
     * @throws ApiError
     */
    public static getContractedInternalInstitutionListEndpoint(
        legalEntityId: string,
    ): CancelablePromise<GetContractedInternalInstitutionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/counterparts/{legalEntityId}/contracted-internal-institutions',
            path: {
                'legalEntityId': legalEntityId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of active contracts per institution.
     * Gets a list of active contracts per institution.
     * @param legalEntityId Legal entity identifier filter.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param activeDate Active date on the basis of which active contracts are selected.The current date is selected by default.
     * @returns GetActiveContractListResponse The list of active contracts has been found.
     * @throws ApiError
     */
    public static getActiveContractListEndpoint(
        legalEntityId: string,
        pageNumber: number = 1,
        pageSize: number = 10,
        activeDate?: string | null,
    ): CancelablePromise<GetActiveContractListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/contracts/active',
            query: {
                'legalEntityId': legalEntityId,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'activeDate': activeDate,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
}
